var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 2015",
    d: "M2 6.81148C2.77676 7.68534 3.3042 8.80468 4.09571 9.68413C4.31738 9.93044 4.59614 10.2455 4.7602 10.5326C4.93033 10.8304 5.13531 11.0234 5.3838 10.7473C5.78521 10.3013 6.12194 9.77405 6.55433 9.34166C7.26578 8.63022 7.89106 7.75631 8.66537 7.09261C9.25344 6.58855 9.60688 5.92109 10.1426 5.38538C10.7079 4.82003 11.2289 4.16617 11.7118 3.54524C12.0186 3.1508 12.5227 2.33217 12.9488 2.11914",
    stroke: "current",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon-check.3e198b717bc44ebb92d2b03af77ba580.svg";
export { ForwardRef as ReactComponent };